<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openLogDialog="openLogDialog"
      @openPODDialog="openPODDialog"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <!--region log dialog -->
    <el-dialog
      v-if="openLogDialogOptions.visible"
      v-el-dialog-drag
      visible
      width="600px"
      title="运单状态"
      :before-close="colseLogDialog"
    >
      <log-page :code="openLogDialogOptions.code" />
      <span slot="footer">
        <el-button size="small" @click="colseLogDialog()">关闭</el-button>
      </span>
    </el-dialog>
    <!-- endregion -->

    <!--region pod dialog -->
    <el-dialog
      v-if="openPODDialogOptions.visible"
      v-el-dialog-drag
      visible
      width="600px"
      title="POD回单"
      :before-close="colsePODDialog"
    >
      <pod-page :code="openPODDialogOptions.code" />
      <span slot="footer">
        <el-button size="small" @click="colsePODDialog()">关闭</el-button>
      </span>
    </el-dialog>
    <!-- endregion -->
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import LogPage from '../log-page'
import PodPage from '../pod-page'
export default {
  components: {
    PageHeader,
    PageMain,
    LogPage,
    PodPage,
  },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      openLogDialogOptions: {
        visible: false,
        code: '',
      },
      openPODDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .carriageWaybillListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openLogDialog(code) {
      this.openLogDialogOptions.code = code
      this.openLogDialogOptions.visible = true
    },
    colseLogDialog() {
      this.openLogDialogOptions.visible = false
    },
    openPODDialog(code) {
      this.openPODDialogOptions.code = code
      this.openPODDialogOptions.visible = true
    },
    colsePODDialog() {
      this.openPODDialogOptions.visible = false
    },
  },
}
</script>
